export const RADAR_AUTOCOMPLETE_API_URL = 'https://api.radar.io/v1/search/autocomplete';

export const RADAR_DEFAULT_COUNTRY = 'US';
export const RADAR_DEFAULT_LIMIT = 5;

/**
 * Radar layer types for filtering autocomplete results.
 *
 * @see {@link https://radar.com/documentation/api#autocomplete}
 */
export const RADAR_LAYERS = {
  ADDRESS: 'address',
  PLACE: 'place',
  POSTAL_CODE: 'postalCode',
  LOCALITY: 'locality',
  COUNTY: 'county',
  STATE: 'state',
  COUNTRY: 'country',
  COARSE: 'coarse',
  FINE: 'fine',
} as const;
